// extracted by mini-css-extract-plugin
module.exports = {"label":"MultiTextInput_healthgenom_label__1srqk","input":"MultiTextInput_healthgenom_input__2rxeQ"};